import { DxpError } from '../../../core/error/dxp-error';

/**
 * La segnalazione non ha cio' che serve a mandarla. La modale spegne gia' il comando finche' manca
 * qualcosa: questo e' il caso di chi arriva alla chiamata per un'altra strada.
 */
export class ReportInvalidError extends DxpError {
  readonly code = 'REPORT_INVALID';

  constructor(what: string) {
    super(`The report cannot be sent: ${what}.`);
  }
}
